import { apiClient } from './client';

/** One participant's recordings, downloadable as one ZIP
 *  (TENANT-RECORDINGS-DOWNLOAD). `key` is the participant's user id, or
 *  `unassigned` for sessions without a participant. */
export interface RecordingBundle {
  key: string;
  name: string;
  sessions: number;
  /** Uploaded video/audio only — the sensor recordings add a little. */
  approx_bytes: number;
}

export async function listRecordingBundles(tenantId: string): Promise<RecordingBundle[]> {
  const { data } = await apiClient.get<RecordingBundle[]>(
    `/api/v1/tenants/${tenantId}/recording-bundles`,
  );
  return data;
}

/** A short-lived URL for one participant's ZIP. Like the session download,
 *  the server returns a relative API path with a signed token; resolve it
 *  against the API base so it reaches the API host in prod. */
export async function getRecordingBundleDownload(
  tenantId: string,
  key: string,
): Promise<{ url: string; filename: string }> {
  const { data } = await apiClient.get<{ url: string; filename: string }>(
    `/api/v1/tenants/${tenantId}/recording-bundles/${key}/download`,
  );
  const base = import.meta.env.VITE_API_URL ?? '';
  const url = /^https?:\/\//.test(data.url) ? data.url : `${base}${data.url}`;
  return { ...data, url };
}
